import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver asked for a load toward home.
 */
export const loadHomeRequestV1 = tmsEventKind(
  { category: "request", kind: "loadHomeRequest", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      /** The vendor field is free text; it reads as an order number but is not validated as one. */
      orderNumber: z.string().nullable(),
    },
  },
);

export const LoadHomeRequestV1Schema = loadHomeRequestV1.schema;
export const LoadHomeRequestV1FactsSchema = loadHomeRequestV1.facts;

export type LoadHomeRequestV1 = z.infer<typeof LoadHomeRequestV1Schema>;
export type LoadHomeRequestV1Facts = z.infer<typeof LoadHomeRequestV1FactsSchema>;

/** Every version of `loadHomeRequest`, keyed by version. What `catalog.ts` places under `request`. */
export const loadHomeRequest = { 1: loadHomeRequestV1 } as const;
